import { useState, useEffect } from 'react';
import { featureFlags, FEATURE_FLAGS } from '@/lib/featureFlags';
import { useAuth } from '@/lib/auth';

export const usePaymentProcessingEnabled = () => {
  const [paymentProcessingEnabled, setPaymentProcessingEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user, organization } = useAuth();

  useEffect(() => {
    const checkFlag = async () => {
      try {
        const enabled = await featureFlags.isEnabled(
          FEATURE_FLAGS.PAYMENT_PROCESSING_ENABLED,
          user?.id,
          organization?.id
        );
        setPaymentProcessingEnabled(enabled);
      } catch (error) {
        console.error('Error checking payment processing flag:', error);
        setPaymentProcessingEnabled(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkFlag();
  }, [user, organization]);

  return { paymentProcessingEnabled, isLoading };
};
